






































































































































import IListPhonePrefix from '@/store/models/IListPhonePrefix';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: {
        Snackbar
    }
})
export default class ListPhonePrefixesSelector extends Vue {
    searchListPhonePrefixes: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'country';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'Country', value: 'country' },
        { text: 'Prefix', value: 'prefix' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : IListPhonePrefix = {
        id: "",
        country: "",
        prefix: "",
        idCompany: ""
    }
    defaultItem : IListPhonePrefix = {
        id: "",
        country: "",
        prefix: "",
        idCompany: ""
    }

    @Prop({ type: Array, required: true })
    ListPhonePrefixesList !: IListPhonePrefix[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];

    selectedListPhonePrefixes : IListPhonePrefix[] = [];

    get formTitle() { return this.editedIndex === -1 ? 'New Phone Prefix' : 'Edit Phone Prefix'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    resetListPhonePrefixes() {
        this.selectedListPhonePrefixes = [];
    }

    editListPhonePrefix (item: any, dbox = true) {
        this.editedIndex = this.ListPhonePrefixesList.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
    }

    saveListPhonePrefix () {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            if (this.editedIndex > -1 || this.selectedListPhonePrefixes[0]) {
                this.close();
                this.$emit('editListPhonePrefix', this.editedItem);
                Object.assign(this.ListPhonePrefixesList[this.editedIndex], this.editedItem);
            } else {
                this.selectedListPhonePrefixes[0] = this.editedItem;
                this.$emit('saveListPhonePrefix', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteListPhonePrefix (phonePrefix: IListPhonePrefix) {
        this.$emit('deleteListPhonePrefix', phonePrefix);
        this.close();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    selectListPhonePrefixes(item : any) : void {
        if (!this.selectedListPhonePrefixes.includes(item)) {
            this.selectedListPhonePrefixes = [];
            this.selectedListPhonePrefixes = [item];
        } else {
            this.selectedListPhonePrefixes = [];
        }
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
